import "./Type.css";
import React, { Fragment, useEffect, useState } from "react";
import { Divider, Select as Select_mui } from "@mui/material";
import Select from "../../../components/Common/Select/Select";
import StatusField from "../../../components/User/Properties/AddProperties/StatusField/StatusField";
// import { City } from "country-state-city";
// import useOnclickOutside from "react-cool-onclickoutside";

// React Places Autocomplete Start
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete"; // getLatLng, // geocodeByAddress,

import { GeoPoint } from "firebase/firestore";
import { QueryTypesense } from "../../../Typesense";
import Map from "../../../components/GoogleMap/Map";
// React Places Autocomplete End

const Type = ({
  register,
  errors,
  watch,
  setValue,
  stepCompletionLookup,
  isStepVisited,
  HomeCat,
  PlotCat,
  CommercialCat,
  SelectedCity,
  setSelectedCord,
  setSelectedCity,
  SelectedLocation,
  setSelectedLocation,
}) => {
  // const [Cities, setCities] = useState([]);
  // const [Locations, setLocations] = useState([]);
  // const [LocationSearch, setLocationSearch] = useState("k");
  const [address, setAddress] = useState("");
  const [coordinates, setCoordinates] = useState({
    lat: null,
    lng: null,
  });

  useEffect(() => {
    setAddress(watch("address"));
    if (watch("lat_lang")) {
      let loc = JSON.stringify(watch("lat_lang"));
      loc = JSON.parse(loc);
      setCoordinates({
        lat: loc.latitude,
        lng: loc.longitude,
      });
    }
  }, []);

  useEffect(() => {
    let geoPoint = new GeoPoint(coordinates.lat, coordinates.lng);

    setValue("lat_lang", geoPoint);
  }, [coordinates]);
  const handleSelect = async (value) => {
    const results = await geocodeByAddress(value);
    const latLng = await getLatLng(results[0]);
    var valueArr = value.split(",");
    setAddress(value);
    setValue("address", value);
    setSelectedCity(valueArr[valueArr.length - 2]);
    setValue("city", valueArr[valueArr.length - 2]);
    setCoordinates(latLng);
    setSelectedCord(latLng);
    let geoPoint = new GeoPoint(latLng.lat, latLng.lng);

    setValue("lat_lang", geoPoint);
  };

  // const searchLocationInDatabase = async () => {
  //   if (LocationSearch === "") {
  //     if (Locations.length > 0) setLocations([]);
  //     return;
  //   }

  //   let LocationsResult = await QueryTypesense(
  //     {
  //       q: LocationSearch,
  //       query_by: "name",
  //     },
  //     "locations"
  //   );
  //   LocationsResult = LocationsResult.map(({ document }) => document);

  //   setLocations([...LocationsResult]);
  // };
  // useEffect(() => searchLocationInDatabase(), [LocationSearch]);

  let options = {
    types: ["(cities)"],
    componentRestrictions: { country: "PK" },
  };
  // useEffect(async () => {
  //   options = {
  //     types: ["(cities)"],
  //     componentRestrictions: { country: "PK" },
  //   };
  //   // Get all cities of pakistan
  //   const cities = City.getCitiesOfCountry("PK");
  //   // const cities = City.getCitiesOfCountry("PK").map(({ name }) => name);
  //   setCities(cities);
  // }, []);

  useEffect(() => {
    /** On uncheck rental checkbox clear rental price */
    const val = watch("availableForRent") ? true : false;
    !val && setValue("rentalPrice", "");
    val && watch("rentalPrice").length == 0 && setValue("rentalPrice", "");
    val && watch("propertyType") === "Plot" && setValue("propertySubType", "");
    val && watch("propertyType") === "Plot" && setValue("propertyType", "");
    val &&
      ["Lower Portion", "Upper Portion"].some(
        (e) => e === watch("propertySubType")
      ) &&
      setValue("propertySubType", "House");
    stepCompletionLookup(1);
  }, [watch("availableForRent")]);

  useEffect(() => {
    /** On uncheck selling checkbox clear selling price */
    const val = watch("availableForSale") ? true : false;
    !val && setValue("sellingPrice", "");
    val && watch("sellingPrice").length == 0 && setValue("sellingPrice", "");
    stepCompletionLookup(1);
  }, [watch("availableForSale")]);

  const onlyRentSelectable = () => setValue("availableForSale", false);
  const onlySaleSelectable = () => setValue("availableForRent", false);

  useEffect(() => {
    setAddress(watch("address"));
  }, [watch("address")]);

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    goToTop();
  }, []);

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-12 col-md-6">
          <span onClick={onlySaleSelectable}>
            <label className="custom-field-title">
              Available for <span style={{ color: "red" }}>*</span>
            </label>
            <StatusField
              status={"Sale"}
              type={"checkbox"}
              name="availableForSale"
              register={{
                ...register("availableForSale", {
                  required: true,
                }),
              }}
              style={{
                color: "black",
              }}
              errors={isStepVisited() && errors}
              watch={watch}
              isStepVisited={isStepVisited}
            />
          </span>
        </div>
        <div
          className="col-12 col-md-6"
          style={{
            marginTop: "5px",
          }}
        >
          <label> &nbsp; </label>

          <span onClick={onlyRentSelectable}>
            <StatusField
              status={"Rent"}
              type={"checkbox"}
              name="availableForRent"
              register={{
                ...register("availableForRent", {
                  required: true,
                }),
              }}
              style={{
                color: "black",
              }}
              errors={isStepVisited() && errors}
              watch={watch}
              isStepVisited={isStepVisited}
            />
          </span>
        </div>
      </div>

      <div className="row mt-sm-5">
        <div className="col-12 col-md-6">
          <label className="custom-field-title">
            Category <span style={{ color: "red" }}>*</span>
          </label>
          {/* Property Type */}
          <Select
            label={"Property Type"}
            list={
              watch("availableForRent") === true
                ? ["Home", "Commercial"]
                : ["Home", "Plot", "Commercial"]
            }
            name={"propertyType"}
            register={{
              ...register("propertyType", { required: true }),
            }}
            errors={isStepVisited() && errors}
            watch={watch}
          />
        </div>
        <div className="col-12 col-md-6">
          {/* Property SubType */}

          {watch("propertyType") && (
            <div>
              <label className="custom-field-title">
                Sub Category <span style={{ color: "red" }}>*</span>
              </label>
              <Select
                label={"Property Sub Type"}
                list={
                  watch("propertyType") === "Home"
                    ? [
                        "House",
                        "Flat",
                        ...(watch("availableForRent") === true
                          ? ["Upper Portion", "Lower Portion"]
                          : []),
                        "Farm House",
                        "Room",
                        "Pent house",
                        "Other",
                        // ...HomeCat,
                      ]
                    : watch("propertyType") === "Plot"
                    ? [
                        "Residential Plot",
                        "Commercial Plot",
                        "Agriculture Plot",
                        "Industrial Land",
                        "Other",
                        // ...PlotCat,
                      ]
                    : watch("propertyType") === "Commercial"
                    ? [
                        "Office",
                        "Shop",
                        "Ware House",
                        "Building",
                        "Other",
                        // ...CommercialCat,
                      ]
                    : []
                }
                name={"propertySubType"}
                register={{
                  ...register("propertySubType", {
                    required: true,
                  }),
                }}
                errors={isStepVisited() && errors}
                watch={watch}
              />
            </div>
          )}
        </div>
      </div>

      <Divider className="my-2 mb-4" />

      <Fragment>
        <div className="row">
          <div className="col-12">
            <label className="custom-field-title">
              Location <span style={{ color: "red" }}>*</span>
            </label>

            <PlacesAutocomplete
              value={address}
              onChange={setAddress}
              onSelect={handleSelect}
              searchOptions={{ componentRestrictions: { country: "pk" } }}
              className="loc-auto-complete"
            >
              {({
                getInputProps,
                suggestions,
                getSuggestionItemProps,
                loading,
              }) => (
                <div className="mb-2">
                  <input
                    className="loc-auto-complete"
                    {...getInputProps({ placeholder: "Location" })}
                  />

                  <div>
                    {loading ? (
                      <div className="loc-auto-complete-content">
                        loading...
                      </div>
                    ) : null}

                    {suggestions.map((suggestion) => {
                      const style = {
                        backgroundColor: suggestion.active ? "#c9c2e4" : "#fff",
                      };

                      return (
                        <div
                          key={suggestion.placeId}
                          className="loc-auto-complete-content"
                          {...getSuggestionItemProps(suggestion, { style })}
                        >
                          {suggestion.description}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </PlacesAutocomplete>

            {coordinates.lat !== null && coordinates.lng !== null ? (
              <Map
                lat={coordinates.lat}
                lang={coordinates.lng}
                setlatLang={setCoordinates}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </Fragment>
    </React.Fragment>
  );
};

export default Type;
